/* eslint-disable camelcase */
import { HttpOnlySecurityService, createNavigationServiceInstance } from '@ipc/iam';
import { UserInformationProvider, useUser } from '@ipc/iam-react';
import { getProperty } from '../services/PropertiesService';

const authenticationUrl = getProperty('REACT_APP_AUTHENTICATION_URL');
export const frontEndUrl = getProperty('REACT_APP_FRONT_END_URL');

const adfsLoginUrl = `${authenticationUrl}/login`;
const adfsLogoutUrl = `${authenticationUrl}/logout`;
const refreshUrl = `${authenticationUrl}/refresh`;
export const failedUrl = `${frontEndUrl}/#/login-failed`;

export const navigationInstance = createNavigationServiceInstance({
  adfsLoginUrl,
  adfsLogoutUrl,
  failed_url: failedUrl,
});

export const httpOnlySecurityService = HttpOnlySecurityService.getInstance({
  cookieName: 'ipciam_expiresAt',
  navigationService: navigationInstance,
  refresh_url: refreshUrl,
});

export { UserInformationProvider, useUser };
